export default {
  name: {
    id: 'rm_metal_tellurium_name',
    defaultMessage: 'Tellurium',
  },
  smartphoneLabel: {
    id: 'rm_metal_tellurium_smartphone_label',
    defaultMessage: 'Trace (invisible to the naked eye)',
  },
  whatItDoesText: {
    id: 'rm_metal_tellurium_what_it_does',
    defaultMessage:
      'Tellurium can be found Inside electronics like PCBs and speakers, but serves no functional role, acting purely as an accidental trace impurity carried over from the copper ores, solders, and conductors it naturally co-occurs with.',
  },
  extractionText1: {
    id: 'rm_metal_tellurium_extraction_p1',
    defaultMessage:
      'Tellurium is rarely mined directly. It is recovered mainly as a by-product of electrolytic copper refining, from anode slimes, with smaller amounts from lead-refinery residues and flue dusts and gases from copper, bismuth and lead-zinc smelting. Anode slimes are treated by distillation, electrolytic refining or solvent extraction to produce high-purity tellurium, reaching up to 99.999% purity.',
  },
  quickFactText: {
    id: 'rm_metal_tellurium_quick_fact',
    defaultMessage:
      'China produced approximately three-quarters of the world’s refined tellurium in 2024.',
  },
  envSummaryText: {
    id: 'rm_metal_tellurium_env_summary',
    defaultMessage:
      'Tellurium’s environmental footprint is largely inherited from copper, lead and zinc mining and smelting. These activities consume energy and water, generate dust, gases, anode slimes and other residues, and can pollute surrounding ecosystems.',
  },
  envWaterText: {
    id: 'rm_metal_tellurium_env_water_text',
    defaultMessage:
      'Copper and lead-zinc mining and processing can consume water and generate polluted wastewater and residues. Tellurium and its compounds may be released during industrial processing, while tellurium can be hazardous to aquatic life.',
  },
  envSoilText: {
    id: 'rm_metal_tellurium_env_soil_text',
    defaultMessage:
      'Tellurium is mainly recovered as a by-product of copper refining, often from sulfide ores. Acid mine drainage from these ores can contaminate topsoil and subsoil with metals, including tellurium. Mining also removes vegetation and topsoil and produces waste rock and tailings. Emissions and poorly managed residues from smelting and refining may further contaminate surrounding soils.',
  },
  humanSummaryText: {
    id: 'rm_metal_tellurium_human_summary',
    defaultMessage:
      'Tellurium can be harmful if inhaled and may cause allergic skin reactions. Available sources also identify potential effects on fertility and the unborn child, although they provide limited evidence of human health impacts specifically associated with tellurium production.',
  },
  humanHealthText: {
    id: 'rm_metal_tellurium_human_health_text',
    defaultMessage:
      'Tellurium may be harmful if inhaled, can cause allergic skin reactions, and may damage fertility or harm the unborn child. The U.S. National Institute for Occupational Safety and Health recommends an exposure limit of 0.1 mg/m³ for tellurium and its compounds, measured as a time-weighted average over a workday.',
  },
  geoSummaryText: {
    id: 'rm_metal_tellurium_geo_summary',
    defaultMessage:
      'Tellurium supply depends mainly on copper refining because the metal is recovered primarily as a by-product. Processing is concentrated in a small number of countries. China produced approximately 75% of estimated global refined tellurium output in 2024 and introduced export licensing requirements for tellurium and certain tellurium compounds in February 2025.',
  },
  geoDugText: {
    id: 'rm_metal_tellurium_geo_dug_text',
    defaultMessage:
      'Tellurium is not normally mined as a standalone metal. More than 90% is recovered from anode slimes generated during the electrolytic refining of copper. Because tellurium is mainly obtained as a by-product, its production is closely linked to countries with copper-refining capacity.',
  },
  geoProcessedText: {
    id: 'rm_metal_tellurium_geo_processed_text',
    defaultMessage:
      'Tellurium is recovered and refined at facilities linked mainly to copper processing. China was the leading producer of refined tellurium in 2024, accounting for approximately 75% of estimated global output.',
  },
  geoLeverageText: {
    id: 'rm_metal_tellurium_geo_leverage_text',
    defaultMessage:
      'In February 2025, China introduced export controls and licensing requirements for tellurium, certain tellurium compounds and related materials, alongside controls covering tungsten and indium. These measures followed earlier Chinese export controls on gallium and germanium in 2023 and antimony in 2024. Since China produced approximately 75% of estimated global refined tellurium output in 2024, changes in its export policy could affect international availability and prices.',
  },
  supplySummaryText: {
    id: 'rm_metal_tellurium_supply_summary',
    defaultMessage:
      'Supply is difficult to expand quickly because tellurium production depends on copper, lead and zinc refining rather than on dedicated tellurium mines. Demand is driven largely by cadmium telluride thin-film solar cells and other high-tech applications',
  },
  supplyReservesText: {
    id: 'rm_metal_tellurium_supply_reserves_text',
    defaultMessage:
      'Tellurium reserves are not reported separately because the metal is mainly recovered as a by-product of copper, lead and zinc processing. Its potential supply is therefore linked to the availability and recovery of tellurium-bearing ores and refinery residues.',
  },
  supplyDemandText: {
    id: 'rm_metal_tellurium_supply_demand_text',
    defaultMessage:
      'Demand is driven mainly by cadmium telluride (CdTe) thin-film solar cells. Tellurium demand for solar photovoltaic applications is projected to fall by approximately 36%, from 1.1 kt in 2025 to 0.7 kt in 2050.',
  },
  recyclingSummaryText: {
    id: 'rm_metal_tellurium_recycling_summary',
    defaultMessage:
      'Tellurium is difficult to recover because it is often used in low concentrations or dispersed during use. Its end-of-life recycling rate is estimated at approximately 1%.',
  },
  recyclingInputText: {
    id: 'rm_metal_tellurium_recycling_input_text',
    defaultMessage:
      'An estimated 1% end-of-life recycling rate has been reported, but this measures the recovery of tellurium from products at the end of their life, not the amount of recycled tellurium used in new products. Small amounts have been recovered from selenium-tellurium photoreceptors in older photocopiers and from defective or end-of-life CdTe solar panels.',
  },
  recyclingOutlookText: {
    id: 'rm_metal_tellurium_recycling_outlook_text',
    defaultMessage:
      'Not currently. Tellurium is often dispersed or present in low concentrations, making recovery difficult. A commercial recycling process exists for some CdTe solar panels, but most installed panels have not yet reached the end of their operational life. Larger quantities may become available for recycling as these panels are retired.',
  },
  footnote1Text1: {
    id: 'rm_metal_tellurium_footnote_1_p1',
    defaultMessage:
      'As Tellurium is not covered by the ADEME 2024 study, its environmental, social, geopolitical and supply-risk scores were calculated by Back Market’s Sustainability team using ADEME’s methodology, public sources and AI assistance. These scores carry greater uncertainty. See the Sources tab for the full methodology and references.',
  },
  footnote2Text1: {
    id: 'rm_metal_tellurium_footnote_2_p1',
    defaultMessage:
      'Tellurium is produced mainly as a by-product of copper refining, rather than from dedicated tellurium mines. Therefore, the section titled “Top Mining Countries” refers to the main countries producing and refining tellurium. The USGS 2025 report provides incomplete data on global refined tellurium production. It reports that China was the leading producer in 2024, accounting for approximately 75% of estimated global output. Production from some countries could not be reliably estimated, and U.S. production was withheld.',
  },
} as const
